// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"5bddb83a","513":"ad696b93","703":"d935fb75","787":"0979e147"}[chunkId] + ".chunk.js";
};